import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AceiteDigitalService {
  private readonly isDigitalAcceptance = new BehaviorSubject<boolean | null>(
    null
  );

  constructor(
    private firestore: AngularFirestore,
    private authService: AuthService
  ) { }

  loadDigitalAcceptanceConfig(): Observable<boolean> {
    return this.firestore
      .doc(`empresaMae/${this.authService.dominioId}/ol_config/feature_flags`)
      .get()
      .pipe(
        map((snap) => !!snap.get('ol_digital_acceptance')),
        tap((value) => this.isDigitalAcceptance.next(value))
      );
  }

  get currentDigitalAcceptance(): boolean | null {
    return this.isDigitalAcceptance.value;
  }
}
